import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '@mui/material';
import { Unit } from 'api/models';
import DishImageTile from 'components/DishImageTile/DishImageTile';
import ItemCard from 'components/ItemCard';
import {
  menuItemImages,
  menuItemName,
  menuItemPortionLabel,
  menuItemUnit,
} from 'utils/menuItem';
import { formatCurrency } from 'utils/string/formatCurrency';
import { Props } from './types';

const CheckoutItemCard: FC<Props> = ({ item, quantity = 0 }) => {
  const { t } = useTranslation();

  // Only weighted items get a total weight — "×2" already says it all for pieces.
  const totalWeight =
    menuItemUnit(item) === Unit.Gram
      ? menuItemPortionLabel(item, t, quantity)
      : undefined;

  const itemName = menuItemName(item);
  return (
    <ItemCard
      image={<DishImageTile urls={menuItemImages(item)} name={itemName} />}
      title={itemName}
      left={
        <Typography color="primary" variant="body1">
          {[`×${quantity}`, totalWeight].filter((part) => !!part).join(', ')}
        </Typography>
      }
      right={
        <Typography component="p" variant="subtitle1">
          {formatCurrency(quantity * item.price)}
        </Typography>
      }
    />
  );
};

export default memo(CheckoutItemCard);
